export default __webpack_public_path__ + "static/media/N.0cc2a4a0.svg";